import { useQuery } from "@tanstack/react-query";
import { PuObrazacListPayload } from "./poreskaUprava.types";
import { poreskaUpravaService } from "./poreskaUprava.service";
import { puObrasciKeys } from "./poreskaUprava.keys";

export function usePuObrasciList({
  filters,
  enabled,
}: {
  filters: PuObrazacListPayload;
  enabled?: boolean;
}) {
  return useQuery({
    ...puObrasciKeys.puObrasciList({ filters }),
    queryFn: () => poreskaUpravaService.getPuObrasci(filters),
    select: (response) => response?.data,
    retry: false,
    enabled,
  });
}
